var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "4edc780655"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.457031 3.695312 L 352.457031 3.695312 L 352.457031 308 L 22.457031 308 Z M 22.457031 3.695312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea44af7dd0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77 113 L 243 113 L 243 371.195312 L 77 371.195312 Z M 77 113 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4edc780655)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 239.289062 276.621094 C 303.457031 265.070312 352.539062 208.609375 352.539062 141.242188 C 352.539062 65.601562 290.652344 3.710938 215.007812 3.710938 L 22.457031 3.710938 L 77.472656 58.726562 L 215.007812 58.726562 C 260.394531 58.726562 297.523438 95.859375 297.523438 141.246094 C 297.523438 186.632812 260.394531 223.765625 215.007812 223.765625 L 187.503906 223.765625 L 187.503906 307.757812 L 242.519531 275.996094 C 241.445312 276.21875 240.371094 276.421875 239.289062 276.621094 Z M 239.289062 276.621094 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea44af7dd0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M 132.488281 278.777344 C 132.488281 242.105469 132.488281 205.429688 132.488281 168.753906 L 215.003906 168.753906 C 230.136719 168.753906 242.511719 156.378906 242.511719 141.246094 C 242.511719 126.117188 230.136719 113.742188 215.003906 113.742188 L 77.472656 113.742188 C 77.472656 168.753906 77.472656 223.765625 77.472656 278.777344 L 77.472656 371.285156 L 132.488281 339.523438 Z M 132.488281 278.777344 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg);
export default __webpack_public_path__ + "static/media/LogoSvg.839b6fc88ac0427dc160f2d7f007de99.svg";
export { ForwardRef as ReactComponent };